import APIService from './apiservice';

const createAIAgentService = (route='api/v1/ai-agent') => {
	const invokeAgent = async (data, endpoint) => {
		const path = `${route}/${endpoint}`;
    	return APIService.doRequest(path, 'POST', data);
  	};

  	return {
	    invokeAgent,
  	};
};

export default createAIAgentService;